export const CLICK_VIDEO = 'click video'

export const CLICK_FEATURED_VIDEO = 'click featured video'

export const CLICK_PROFILE = 'click profile'

export const CLICK_FEATURED_PROFILE = 'click featured profile'

export const SWTICH_PROFILE_TAB = 'switch profile tab'

export const DISCONNECT_WALLET = 'disconnect wallet'

export const OPEN_ACCOUNT_DROPDOWN = 'open account dropdown'

export const CLOSE_ACCOUNT_DROPDOWN = 'close account dropdown'

export const CLICK_CONNECT_WALLET = 'click connect wallet'

export const CONNECT_WALLET = 'connect wallet'

export const CLICK_BUY = 'click buy'

export const CLICK_SELL = 'click sell'

export const CLICK_LIST_FOR_SALE = 'click list for sale'

export const CLICK_ADD_TO_CALENDAR = 'add to calendar'

export const CLICK_CANCEL_LISTING = 'click cancel listing'

export const CLICK_BUY_ON_LISTING = 'click buy on listing'

export const CLICK_BUY_IN_VIDEOPLAYER = 'click buy in videoplayer'

export const CLICK_SELL_IN_VIDEOPLAYER = 'click sell in videoplayer'

export const CLICK_ADD_TO_CALENDAR_IN_VIDEOPLAYER = 'click add to calendar in videoplayer'

export const CLICK_OFFER_TO_BUY = 'click offer to buy'

// ========================= Helper Functions ==================================

export const getPageName = (pathname: string): string => {
  if (pathname.match(/\/v\/[a-zA-Z0-9]+/)) {
    return 'video'
  } else if (pathname.match(/\/p\/[a-zA-Z0-9]+/)) {
    return 'profile'
  } else {
    return 'home'
  }
}
